<template>
  <section class="contact-section" :class="{ 'dark-mode': isDarkMode }">
    <form @submit.prevent="submitForm" class="contact-form">
      <div class="form-group">
        <div class="form-left">
          <div class="form-control">
            <label for="nome">Nome*</label>
            <input type="text" id="nome" v-model="formData.nome" required />
          </div>
          <div class="form-control">
            <label for="email">E-mail*</label>
            <input type="email" id="email" v-model="formData.email" required />
          </div>
          <div class="form-control">
            <label for="telefone">Telefone</label>
            <input type="tel" id="telefone" v-model="formData.telefone" />
          </div>
        </div>
        <div class="form-right">
          <div class="form-control">
            <label for="mensagem">Mensagem</label>
            <textarea id="mensagem" v-model="formData.mensagem" required></textarea>
          </div>
        </div>
      </div>
      <button type="submit" class="cta-button">Enviar Mensagem</button>

      <p v-if="mensagemEnviada" class="success-message">Mensagem enviada com sucesso!</p>
    </form>
  </section>
</template>

<script>
export default {
  props: {
    isDarkMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formData: {
        nome: "",
        email: "",
        telefone: "",
        mensagem: "",
      },
      mensagemEnviada: false,
    };
  },
  methods: {
    submitForm() {
      this.mensagemEnviada = true;

      this.formData = {
        nome: "",
        email: "",
        telefone: "",
        mensagem: "",
      };

      setTimeout(() => {
        this.mensagemEnviada = false;
      }, 5000);
    },
  },
};
</script>

<style scoped>
.contact-section {
  background-color: #f5f5f5;

  display: flex;
  justify-content: center;
  align-items: center;

  text-align: center;
}

.contact-section.dark-mode {
  background-color: #274862;
}

.contact-form {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 800px;
}

.form-group {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 20px;
  width: 100%;
}

.form-left {
  display: flex;
  flex-direction: column;
  width: 45%;
}

.form-right {
  display: flex;
  flex-direction: column;
  width: 45%;
}

.form-control {
  margin-bottom: 20px;
  width: 100%;
}

.form-control label {
  display: block;
  margin-bottom: 10px;
  font-weight: 600;
  color: #274862;
}

.contact-section.dark-mode .form-control label {
  color: white;
}

.form-control input,
.form-control textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 1em;
}

.form-control textarea {
  height: 150px;
}

.contact-section.dark-mode .form-control input,
.contact-section.dark-mode .form-control textarea {
  background-color: #f5f5f5;
}

.cta-button {
  padding: 15px 30px;
  background-color: #9dee9c;
  border: none;
  color: #274862;
  font-size: 1em;
  cursor: pointer;
  border-radius: 5px;
  font-weight: 600;
  margin-top: 20px;
}

.cta-button:hover {
  background-color: #82c582;
}

.success-message {
  margin-top: 20px;
  color: #28a745;
  font-weight: 600;
  font-size: 1.1em;
}

@media (max-width: 1024px) {
  .form-left,
  .form-right {
    width: 48%;
  }
}

@media (max-width: 768px) {
  .form-group {
    flex-direction: column;
    align-items: center;
  }

  .form-left,
  .form-right {
    width: 100%;
  }

  .form-control textarea {
    height: 120px;
  }

  .cta-button {
    padding: 10px 20px;
  }
}

@media (max-width: 480px) {
  .form-control input,
  .form-control textarea {
    font-size: 0.9em;
  }

  .cta-button {
    width: 100%;
    padding: 12px 0;
  }
}
</style>
